import React from "react";
import {
  makeStyles,
  Typography,
  Box,
  Container,
  Grid,
  Button,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

export default function AboutPage() {
  const useStyles = makeStyles((theme) => ({
    aboutPage: {
      backgroundImage: 'url("/assets/images/Home/introduction.png")',
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      position: "absolute",
      left: 0,
      right: 0,
      top: 64,
      bottom: 0,
      filter: "brightness(0.8)",
    },
  }));
  const classes = useStyles();
  return (
    <Box>
      <Box className={classes.aboutPage}></Box>
      <Box position="relative" zIndex="2" pt={40}>
        <Container maxWidth="lg">
          <AboutStory />
          <AboutIdea />
          <AboutAdvantage />
        </Container>
      </Box>
    </Box>
  );
}

// ANCHOR AboutStory1
function AboutStory() {
  const theme = useTheme();
  const history = useHistory();
  const isDownPc = useMediaQuery("(max-width:960px)");
  const useStyles = makeStyles((theme) => ({
    title: {
      margin: isDownPc ? "32px auto" : "",
    },
    content: {
      alignSelf: "flex-end",
      width: isDownPc ? "" : "70%",
      margin: isDownPc ? "0 auto" : "",
    },
  }));
  const classes = useStyles();
  return (
    <Box mb={8}>
      <Grid container justify="sapce-between" spacing={4}>
        {/* title */}
        <Grid container item xs={12} md={6}>
          <Box className={classes.title}>
            <Typography
              style={{ color: theme.palette.secondary.light }}
              variant="h3"
            >
              <u>品牌故事</u>
            </Typography>
          </Box>
          {/* content */}
          <Box className={classes.content} my={4}>
            <Typography
              variant="body2"
              style={{ color: theme.palette.secondary.light }}
            >
              富屋相關企業立足中台灣地區至今已經二十餘年，
              早期由旅館業發跡，民國八十年初，富屋體系直營
              旅館與汽車旅館達八家，至民國八十三年起看準法
              拍市場所具的頭資潛力，進而逐步轉型推展至...
            </Typography>
            <Box mt={1}>
              <Button
                style={{ color: theme.palette.secondary.light }}
                onClick={() => history.push("./brand-story")}
              >
                <Typography variant="body2">
                  <Box display="flex" alignItems="center">
                    點我看更多
                    <ArrowForwardIcon style={{ width: "20px" }} />
                  </Box>
                </Typography>
              </Button>
            </Box>
          </Box>
        </Grid>

        {/* 圖片 */}
        <Grid container item xs={12} md={6} justify="center">
          <img
            src={"/assets/images/About/storyImage.jpg"}
            style={{ borderRadius: "10px" }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

// ANCHOR AboutIdea

function AboutIdea() {
  const theme = useTheme();
  const history = useHistory();
  const isDownPc = useMediaQuery("(max-width:960px)");
  const useStyles = makeStyles((theme) => ({
    title: {
      margin: isDownPc ? "32px auto" : "0 0 32px",
    },
    content: {
      // alignSelf: "flex-end",
      width: isDownPc ? "" : "70%",
      margin: isDownPc ? "32px auto" : "0",
    },
  }));
  const classes = useStyles();

  const ideaList = [
    {
      label: "●最高經營指導方針●",
    },
    {
      label: "正派經營、誠信服務、光明正氣、專業負責、永續經營",
    },
    {
      label: "最高經營理念：【三大原則、五大信念】 ......",
    },
  ];

  return (
    <Box mb={8}>
      <Grid container justify="sapce-between" spacing={0}>
        {/* title */}
        <Grid
          container
          item
          xs={12}
          md={6}
          style={{ order: isDownPc ? "" : 2 }}
        >
          <Box
            mx="auto"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
          >
            <Box className={classes.title}>
              <Typography color="primary" variant="h3">
                <u>經營理念</u>
              </Typography>
            </Box>
            {/* content */}
            <Box className={classes.content}>
              {ideaList.map((item) => (
                <Typography variant="body2" color="primary">
                  {item.label}
                </Typography>
              ))}

              <Box mt={1}>
                <Button
                  color="primary"
                  onClick={() => history.push("./brand-story")}
                >
                  <Typography variant="body2">
                    <Box display="flex" alignItems="center">
                      點我看更多
                      <ArrowForwardIcon style={{ width: "20px" }} />
                    </Box>
                  </Typography>
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* 圖片 */}
        <Grid
          container
          item
          xs={12}
          md={6}
          justify="center"
          style={{ order: isDownPc ? "" : 1 }}
        >
          <img
            src={"/assets/images/About/storyImage.jpg"}
            style={{ borderRadius: "10px" }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

// ANCHOR  AboutAdvantage
window.addEventListener("onmousedown", function (e) {
  alert("測試");
});

function AboutAdvantage() {
  const theme = useTheme();
  const history = useHistory();
  const isDownPc = useMediaQuery("(max-width:960px)");
  const useStyles = makeStyles((theme) => ({
    title: {
      margin: isDownPc ? "32px auto" : "",
    },
    content: {
      alignSelf: "flex-end",
      width: isDownPc ? "" : "70%",
      margin: isDownPc ? "0 auto" : "",
    },
  }));
  const classes = useStyles();
  return (
    <Box>
      <Grid container justify="sapce-between" spacing={4}>
        {/* title */}
        <Grid container item xs={12} md={6}>
          <Box className={classes.title}>
            <Typography color="primary" variant="h3">
              <u>品牌故事</u>
            </Typography>
          </Box>
          {/* content */}
          <Box className={classes.content} my={4}>
            <Typography variant="body2" color="primary">
              富屋相關企業立足中台灣地區至今已經二十餘年，
              早期由旅館業發跡，民國八十年初，富屋體系直營
              旅館與汽車旅館達八家，至民國八十三年起看準法
              拍市場所具的頭資潛力，進而逐步轉型推展至...
            </Typography>
            <Box mt={1}>
              <Button
                color="primary"
                onClick={() => history.push("./brand-story")}
              >
                <Typography variant="body2">
                  <Box display="flex" alignItems="center">
                    點我看更多
                    <ArrowForwardIcon style={{ width: "20px" }} />
                  </Box>
                </Typography>
              </Button>
            </Box>
          </Box>
        </Grid>

        {/* 圖片 */}
        <Grid container order="1" item xs={12} md={6} justify="center">
          <img
            src={"/assets/images/About/storyImage.jpg"}
            style={{ borderRadius: "10px" }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
